<template>
  <div class="table-content">
    <div class="header">
      <div class="headerLeft">
         <div class="filiale">
          <el-select class="fil" v-model="value" @change="onSelectedDrug" size="small" filterable collapse-tags
            placeholder="请选择内外勤" :popper-append-to-body="false">
            <el-option v-for="item in officers" :key="item.value" :label="item.label" :value="item.value">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="filiale">
          <el-select class="fil" v-model="value1" size="small" @change="onSelectedDrug1" filterable collapse-tags
            placeholder="请选择分公司" :popper-append-to-body="false">
            <el-option v-for="item in filiale" :key="item.companyId" :label="item.companyName" :value="item.companyId">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.companyName }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="filiale">
          <el-select v-model="value2" :popper-append-to-body="false" size="small" @change="onSelectedDrug2" filterable collapse-tags placeholder="请选择中支">
            <el-option v-for="item in medium" :key="item.deptId" :label="item.deptName" :value="item.deptId">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.deptName }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="filiale">
          <el-select v-model="value3" :popper-append-to-body="false" size="small" @change="onSelectedDrug3" filterable collapse-tags placeholder="请选择营服">
            <el-option v-for="item in camp" :key="item.businessId" :label="item.businessName" :value="item.businessId">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.businessName }}</span>
            </el-option>
          </el-select>
        </div>
        <!--日期选择-->
        <div class="startDate">
          <el-date-picker v-model="date1" size="small" type="date" @change="getSTime1" placeholder="开始日期"
            :picker-options="getSTime1Fun">
          </el-date-picker>
        </div>
        <div class="endDate">
          <el-date-picker v-model="date2" size="small" type="date" @change="getSTime2" placeholder="结束日期"
            :picker-options="getSTime2Fun">
          </el-date-picker>
        </div>
      </div>
      <div class="fun">
          <el-row>
            <el-button class="search" size="mini" @click="search()">搜索</el-button>
            <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
            <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
          </el-row>
      </div>
    </div>
    <el-table class="loadingPrivate" max-height="500" :data="tableData" style="width: 100%,font-size:0.5rem,margin-bottom:1rem">
      <el-table-column prop="orderNumber" label="排名" width="100"></el-table-column>
      <el-table-column prop="recommendPepole" label="推荐人姓名" width="150"></el-table-column>
      <el-table-column prop="recommendIdcard" label="身份证号" width="160"></el-table-column>
      <el-table-column prop="companyName" label="分公司" width="180"></el-table-column>
      <el-table-column prop="deptName" label="中支" width="160"></el-table-column>
      <el-table-column prop="serviceName" label="营服" width="160"></el-table-column>
      <el-table-column prop="identityType" label="内/外勤" width="160"></el-table-column>
      <el-table-column prop="countFlag" label="被推荐开户数" width="170"></el-table-column>
    </el-table>
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "rank3", //个人排名表
    data() {
      return {
        tableData: [],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 15, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        officers:[{
          value: 'A',
          label: '内勤'
        },{
          value: '1',
          label: '外勤'
        }],
        value: [],
        value1: [],
        value2: [],
        value3: [],
        value4: [],
        input1: '',
        input2: '',
        date1: '', //开始日期
        date2: '', //结束日期
        filiale: [], //分公司
        medium: [], //中支
        camp: [], //营服
        isPage: true,
        token: "",
        pagNum: "", //总页数
        pageNumber: 1, //页码数
        pageSize: 15, //每页条数
        totalCount: "", //总条数
        identityClass: "", //员工类别名称
        identityClassID: "", //员工类别id
        identityType: "", //员工标识:1内勤2外勤
        companyId: "", //分公司Id
        companyName: "", //公司名称
        serviceName: "", //营服名
        serviceID: "", //营服id
        startTime: "", //开始时间
        endTime: "", //结束时间
        recommendIdcard: "", //推荐人身份证号
        recommendPepole: "", //推荐人姓名
        recommendMobile: "", //推荐人手机号
        toRecommendIdcard: "", //被推荐人身份证号
        toRecommendName: "", //被推荐人姓名
        toRecommendMobile: "", //被推荐人手机号
        deptId: "", //中支id
        abbrName: "", //中支名称
        selectData: [], //导出excel文件
        excelData: [],
        //请求参数
        req: {
          identityType1: "", //员工标识:1内勤2外勤
          companyName1: "", //公司名称
          serviceName1: "", //营服名
          startTime1: "", //开始时间
          endTime1: "", //结束时间
          recommendIdcard1: "", //推荐人身份证号
          recommendPepole1: "", //推荐人姓名
          deptId1: "", //中支id
          companyId1: "", //公司id
          serviceId1:"",//营服id
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        },
        isclick:false,
      }
    },
    props: {},
    created() {
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.firstSearch();//首次进入页面加载所有数据
      // this.pagNumS()
    },
    mounted() {},
    methods: {
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
          identityType: this.req.identityType1, //员工标识:1内勤2外勤
          companyId: this.req.companyId1, //公司ID
          deptId:this.req.deptId1,//中支id
          serviceId:this.req.serviceId1,//营服id
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize
        };
        console.log("bbbbbbbbb", params)
        let _this = this;
        let url = '/ft-oms/companySortController/employeeOpenSort.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {

      },
      //获取类别ID和名称
      onSelectedDrug(id) {
        //单选filterable
        let obj = {};
        obj = this.officers.find((item) => { //这里的userList就是上面遍历的数据源
          return item.value === id; //筛选出匹配数据
        });
        // console.log("obj", obj)
        console.log(id); //获取的 id
        // console.log(obj.label); //获取的名称
        this.identityClass = obj.label;
        this.identityClassID = id;
        this.referrerFil();
        //多选multiple
        // let resultArr = this.options.filter((ele, index, arr) => {
        //   return id.some(item => {
        //     return item === ele.value
        //   });
        // });
        // console.log("item====",resultArr)
      },
      //获取分公司ID和名称
      onSelectedDrug1(id) {
        let obj = {};
        obj = this.filiale.find((item) => { //这里的userList就是上面遍历的数据源
          return item.companyId === id; //筛选出匹配数据
        });
        console.log("分公司", id); //获取的 id
        this.companyName = obj.companyName;
        this.companyId = id;
        // if (obj.identity) { //类别为所有时，重新定义this.identityClassID
        //   this.identityClassID = obj.identity
        // } else {

        // }
        this.referrerMed();
      },
      //获取中支ID和名称
      onSelectedDrug2(id) {
        let obj = {};
        obj = this.medium.find((item) => { //这里的userList就是上面遍历的数据源
          return item.deptId === id; //筛选出匹配数据
        });
        console.log("中支", id); //获取的 id
        this.deptId = id;
        console.log("this.deptId", this.deptId); //获取的 id
        this.abbrName = obj.deptName
        this.referrerCc();
      },
      //获取营服ID和名称
      onSelectedDrug3(id) {
        let obj = {};
        obj = this.camp.find((item) => { //这里的userList就是上面遍历的数据源
          return item.businessId === id; //筛选出匹配数据
        });
        console.log("营服", id); //获取的 id
        this.serviceID = id;
        this.serviceName = obj.businessName
      },
      //获取开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var youWant = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
        console.log(youWant)
        if(youWant=="1970/1/1"){
          youWant=""
        }
        this.startTime = youWant
        console.log("this.startTime",this.startTime)
        // this.endTime = youWant2
      },
      //获取结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate();
        console.log(youWant2)
        if(youWant2=="1970/1/1"){
          youWant2=""
        }
        // this.startTime = youWant
        this.endTime = youWant2
        console.log("this.endTime",this.endTime)

      },
      //获取推荐人身份证号
      recommendIdcardBlur() {
        if (this.recommendIdcard.length >= 18) {
          this.recommendIdcard = this.recommendIdcard.substring(0, 18);
        }
      },
      //获取推荐人姓名
      recommendPepoleBlur() {
        this.recommendPepole = this.recommendPepole.replace(
          /[^\u4e00-\u9fa5a-zA-Z\d,\.\/\·]+/,
          ""
        );
        if (this.recommendPepole.length >= 25) {
          this.recommendPepole = this.recommendPepole.slice(0, 25);
        }
      },
      //首次进入加载数据
      firstSearch() {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          identityType:"",//员工类别
          companyId: "", //公司id
          deptId:"",//中支id
          serviceId:"",//营服id
          startTime: "", //开始时间
          endTime: "", //结束时间
          token: this.token
        };
        let _this = this;
        let url = '/ft-oms/companySortController/employeeOpenSort.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //搜索
      search() {
        if((this.startTime!=''&&this.endTime!='')||(this.startTime==''&&this.endTime=='')){
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          identityType:this.identityClassID,//员工类别
          companyId:this.companyId,//公司Id
          deptId:this.deptId,//中支id
          serviceId:this.serviceID,//营服id
          startTime: this.startTime, //开始时间
          endTime: this.endTime, //结束时间
          token: this.token
        };

        this.req.identityType1 = params.identityType
        this.req.companyName1 = params.companyName
        this.req.serviceName1 = params.serviceName
        this.req.startTime1 = params.startTime
        this.req.endTime1 = params.endTime
        this.req.recommendIdcard1 = params.recommendIdcard
        this.req.recommendPepole1 = params.recommendPepole
        this.req.deptId1 = params.deptId
        this.req.companyId1= params.companyId
        this.req.serviceId1=params.serviceId

        let _this = this;
        let url =  '/ft-oms/companySortController/employeeOpenSort.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.data
            this.totalCount = parseInt(res.data.data.totalCount)
            this.currentPage1 = 1
            this.pagNumS();
            this.isPage = true
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }else{
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
        }else{
          this.$alert('请选择开始日期或结束日期', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
                // this.$message({
                // type: 'info',
                // message: `action: ${ action }`
                // });
            }
          });
        }
      },
      //清除
      deltale() {
        this.value = ""
        this.identityClassID = "";
        this.value1 = ""
        this.companyName = "";
        this.value2 = ""
        this.abbrName = "";
        this.value3 = ""
        this.serviceName = "";
        this.date1 = "";
        this.date2 = "";
        this.startTime = "";
        this.endTime = "";
        this.recommendIdcard = "";
        this.recommendPepole = "";
        this.deptId = "";
        this.companyId = "";
        this.serviceID="";
      },
      //导出
      doexcel() {
        let params = {
          identityType: this.req.identityType1, //员工标识:1内勤2外勤
          companyId: this.req.companyId1, //公司ID
          deptId:this.req.deptId1,//中支id
          serviceId:this.req.serviceId1,//营服id
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token
        };
        let _this = this;
        let url = '/ft-oms/companySortController/isExportEmployeeSortProcess.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          }else{
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
        }, );
      },
      //查分公司
      referrerFil() {
        let params = {
          "identity": this.identityClassID,
          token: this.token
        };
        console.log("55555", params);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryCompany.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1", res.data)
            this.filiale = res.data.data.list
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          } else {
          }
        }, );
      },
      //查中支
      referrerMed() {
        let params = {
          "identity": this.identityClassID,
          token: this.token,
          "companyId": this.companyId
        };
        console.log("55555", params);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryDept.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1", res.data)
            this.medium = res.data.data.list
            console.log("this.medium+++", this.medium)
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          } else {
          }
        }, );
      },
      //查营服
      referrerCc() {
        let data = {
          "identity": this.identityClassID,
          token: this.token,
          "deptId": this.deptId
        };
        console.log("55555", data);
        let _this = this;
        let url =  '/ft-oms/OipController/oipQueryDeptBusiness.action'
        this.$http.post(url, data).then(res => {
          if (res.data.code == "200") {
            this.camp = res.data.data.list
            console.log("this.camp", this.camp)
          }else if(res.data.code=="99999"){
            if(res.data.data.code=='88886'){
              this.$router.push({
                path:"/login"
              })
            }
          } else {
          }
        }, );
      },
    }
  }

</script>

<style scoped>
  body {
    margin: 0;
  }

  .pagination {
    /* margin-bottom: 1.2rem; */
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;

  }

  .header {
    height: 3rem;
    display: flex;
    justify-content: space-between;
  }

  .filiale,
  .input {
    margin-right: 0.5rem;
  }

  .startDate,
  .endDate {
    margin-right: 0.5rem;
  }

  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
    /* margin-right: 0.6rem; */
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
    /* margin-right: 0.6rem; */
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxImg {
    width: 4.8rem;
    height: 1.2rem;
    border: 1px solid #999999;
    background: url("../../../static/img/sousuo-2.png") no-repeat center right;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }
  .headerLeft{
    display: flex;
  }
  .fun {
    display: flex;
    /* margin-top: 1rem; */
    margin-bottom: 1rem;
    float: right;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 9rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 5rem;
    outline: none;
  }

  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }

  
  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }
  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }
  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 8rem;
  }

  .startDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  .endDate>>>.el-date-editor {
    width: 8rem;
  }
  .endDate>>>.el-input__inner:focus{
    border-color: #FF9D47;
  }
  
  /*修改下拉框样式*/
  .filiale>>>.el-input__inner{
    width: 8rem;
  }
  /* .el-select-dropdown__wrap {
    background: #b5879a !important;
  } */
  .filiale>>>.el-select .el-input.is-focus .el-input__inner{
    border-color: #FF9D47;
  }
  .filiale>>>.el-select .el-input__inner:focus{
    border-color: #FF9D47;

  }
  .el-select-dropdown__item.selected{
    color: #FF9D47;
  }
  .el-select-dropdown__item.hover{
    background-color: #ffffff;
  }
  .filiale>>>.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #FAF0E7;
    color: #FF9D47;
  }
  
  /*修改分页样式*/
  .pagination>>>.el-pager li.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pager li:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .pagination>>>.el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .el-icon-arrow-left:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-right:hover{
    color: #FF9D47;
  }
  .el-icon-arrow-left.active{
    color: #FF9D47;
  }
  .el-icon-arrow-right.active{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-next:hover{
    color: #FF9D47;
  }
  .pagination>>>.el-pagination .btn-prev:hover{
    color: #FF9D47;
  }
  
 /*按钮样式*/
  .doexcel>>> .el-button--default .el-button--mini:hover{
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }
  .search>>>.el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }
  .deltale>>> .el-button--default .el-button--mini:hover{
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }
  /*修改table样式*/
  .table-content>>>.el-table thead.is-group th{
    background-color: #ffffff;
  }
  .table-content>>>.el-table .cell {
    text-align: center;
  }
  .filiale >>>.el-select-dropdown__wrap{
    max-height: 295px;
  }
</style>



// WEBPACK FOOTER //
// rank3.vue?1b16b2a4